import React from 'react';
import { createElement } from 'react';
import { Box, Select, Input, Button, Icon } from '@alifd/next';
import { entityDataUtil } from 'oadp-common';
const ConditionItem = ({ condition, attributeDataSource, onRemove, onChange }) => {
    console.log('ConditionItem render condition', condition);
    const [referValueDataSource, setReferValueDataSource] = React.useState([]);
    const [needInitReferValueDataSource = true, setNeedInitReferValueDataSource] = React.useState([]);
    const valueTypeDataSource = [
        { value: 'MEMBER', label: '成员值' },
        { value: 'ATTRIBUTE', label: '属性值' },
        { value: 'FORMULA', label: '公式值' },
    ];
    const getOperators = (attribute) => {
        console.log('OadpEntityButtonReadRule getOperators begin with attribute:', attribute, attributeDataSource);
        const defaultOperators = [
            { value: 'equals', label: '等于' },
            { value: 'contains', label: '包含' },
            { value: 'startsWith', label: '开头是' },
            { value: 'endsWith', label: '结尾是' }
        ];
        try {
            console.log('OadpEntityButtonReadRule getOperators begin with at!Array.isArray(attributeDataSource) :', !Array.isArray(attributeDataSource));
            if (!attribute || !Array.isArray(attributeDataSource)) {
                return defaultOperators;
            }
            const attributeWithRefer = attributeDataSource.find((item) => item.logicalName === attribute);
            if (!attributeWithRefer) {
                return defaultOperators;
            }
            const attributeType = attributeWithRefer?.attributeType;
            console.log('getOperators begin with attributeType:', attributeType);
            switch (attributeType.code) {
                case 'TEXT':
                case 'MULTI_TEXT':
                case 'NUMBER':
                case 'DECIMAL':
                case 'UUID':
                case 'AUTO_CODE':
                    return [
                        { value: 'equals', label: '等于' },
                        { value: 'contains', label: '包含' },
                        { value: 'startsWith', label: '开头是' },
                        { value: 'endsWith', label: '结尾是' }
                    ];
                case 'BOOLEAN':
                case 'ENUM':
                case 'MULTI_ENUM':
                case 'REFER':
                case 'NULTI_REFER':
                    return [
                        { value: 'equals', label: '等于' },
                        { value: 'in', label: '属于' },
                        { value: 'notIn', label: '不属于' }
                    ];
                default:
                    return [
                        { value: 'equals', label: '等于' },
                        { value: 'contains', label: '包含' },
                        { value: 'startsWith', label: '开头是' },
                        { value: 'endsWith', label: '结尾是' }
                    ];
            }
        }
        catch (error) {
            console.error('Error in getOperators:', error);
            return defaultOperators;
        }
    };
    const handleValueFocus = async (attribute) => {
        if (!attribute)
            return;
        const attributeWithRefer = attributeDataSource.find((item) => item.logicalName === attribute);
        const { valueType } = condition;
        if (valueType === 'MEMBER') {
            const conditionData = {
                "model": attributeWithRefer.referEntity?.logicalName || '',
                "orderBy": [
                    {
                        "attribute": "updateAt",
                        "operator": "desc"
                    }
                ],
                "pageNum": 1,
                "pageSize": 1000
            };
            const response = await entityDataUtil.asyncSelectPageListByCondition(attributeWithRefer.referEntity?.logicalName || '', conditionData);
            console.log('response', response);
            const dataSourceArray = [];
            response.data.list.forEach((item) => {
                dataSourceArray.push({
                    label: item.name,
                    value: item.id,
                });
            });
            setReferValueDataSource(dataSourceArray);
            console.log("dataSourceArray return", dataSourceArray);
        }
        else if (valueType === 'ATTRIBUTE') {
            const dataSourceArray = [];
            attributeDataSource.forEach((item) => {
                if (item.referEntity && attributeWithRefer.referEntity && item.referEntity.id === attributeWithRefer.referEntity.id) {
                    dataSourceArray.push({
                        label: item.label,
                        value: item.value,
                    });
                }
            });
            setReferValueDataSource(dataSourceArray);
            console.log("dataSourceArray return", dataSourceArray);
        }
    };
    const renderValue = () => {
        const { id, attribute, valueType, value } = condition;
        if (!attribute || !Array.isArray(attributeDataSource)) {
            return (createElement(Input, { style: { width: 100 }, hasBorder: false, value: value, onChange: v => onChange(id, { value: v }), placeholder: "\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22", hasClear: true, hoverShowClear: true }));
        }
        const attributeWithRefer = attributeDataSource.find((item) => item.logicalName === attribute);
        console.log('renderValue begin with attribute', attribute, value, attributeWithRefer);
        const attributeType = attributeWithRefer?.attributeType;
        switch (attributeType?.code) {
            case 'TEXT':
            case 'MULTI_TEXT':
            case 'NUMBER':
            case 'DECIMAL':
            case 'UUID':
            case 'AUTO_CODE':
                return (createElement(Input, { style: { width: 100 }, hasBorder: false, value: value, onChange: v => onChange(id, { value: v }), placeholder: "\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22" }));
            case 'BOOLEAN':
                const booleanValueDataSource = [{
                        label: '是',
                        value: 'true'
                    }, {
                        label: '否',
                        value: 'false'
                    }];
                return (createElement(Select, { style: { width: 100 }, hasBorder: false, autoWidth: false, value: value, onChange: v => onChange(id, { value: v }), placeholder: "\u8BF7\u9009\u62E9", dataSource: booleanValueDataSource }));
            case 'ENUM':
            case 'MULTI_ENUM':
            case 'REFER':
            case 'NULTI_REFER':
                if (needInitReferValueDataSource) {
                    if (valueType === 'MEMBER') {
                        const conditionData = {
                            "model": attributeWithRefer.referEntity?.logicalName || '',
                            "orderBy": [
                                {
                                    "attribute": "updateAt",
                                    "operator": "desc"
                                }
                            ],
                            "pageNum": 1,
                            "pageSize": 1000
                        };
                        entityDataUtil.selectPageListByCondition(attributeWithRefer.referEntity?.logicalName || '', conditionData, (response) => {
                            console.log('response', response);
                            const dataSourceArray = [];
                            response.data.list.forEach((item) => {
                                dataSourceArray.push({
                                    label: item.name,
                                    value: item.id,
                                });
                            });
                            setReferValueDataSource(dataSourceArray);
                            setNeedInitReferValueDataSource(false);
                        });
                    }
                    else if (valueType === 'ATTRIBUTE') {
                        const dataSourceArray = [];
                        attributeDataSource.forEach((item) => {
                            if (item.referEntity && attributeWithRefer.referEntity && item.referEntity.id === attributeWithRefer.referEntity.id) {
                                dataSourceArray.push({
                                    label: item.label,
                                    value: item.value,
                                });
                            }
                        });
                        setReferValueDataSource(dataSourceArray);
                        setNeedInitReferValueDataSource(false);
                    }
                }
                return (createElement(Select, { style: { width: 100 }, hasBorder: false, autoWidth: false, value: value, onChange: v => onChange(id, { value: v }), placeholder: "\u8BF7\u9009\u62E9", onFocus: () => handleValueFocus(attribute), dataSource: referValueDataSource }));
            default:
                return (createElement(Input, { style: { width: 100 }, hasBorder: false, value: value, onChange: v => onChange(id, { value: v }), placeholder: "\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22" }));
                ;
        }
    };
    return (createElement(Box, { direction: "row", align: "center", justify: "left", style: { border: '1px solid #ccc' } },
        createElement(Select, { value: condition?.attribute || undefined, hasBorder: false, autoWidth: false, onChange: v => {
                console.log('v', v);
                const attributeValue = (Array.isArray(v) ? v[0] : v)?.value || v;
                onChange(condition.id, {
                    attribute: attributeValue,
                    operator: getOperators(attributeValue)[0]?.value || ''
                });
            }, style: { width: 60 }, dataSource: attributeDataSource, placeholder: "\u8BF7\u9009\u62E9\u5B57\u6BB5" }),
        renderValue(),
        createElement(Button, { className: "action-button", text: true, onClick: () => onRemove(condition.id) },
            createElement(Icon, { type: "close", size: "xs" }))));
};
export default ConditionItem;
